<div *ngIf="config.fields.includes('type')">
    <label for="">{{ 'FEATURES.AGREEMENTS.COLUMNS.AGREEMENTTYPENAME' | translate }}</label>
    <app-multi-select
        [searchable]="true"
        [items]="data.type"
        [ngModel]="selectedFilter.type"
        (selectChange)="onMultiSelectChange('type', $event)"
    />
</div>
<div *ngIf="config.fields.includes('categories')">
    <label for="">{{ 'FEATURES.AGREEMENTS.COLUMNS.CATEGORY' | translate }}</label>
    <app-multi-select
        [searchable]="true"
        [items]="data.categories"
        [ngModel]="selectedFilter.categories"
        (selectChange)="onMultiSelectChange('categories', $event)"
    />
</div>
<div *ngIf="config.fields.includes('areas')">
    <label for="">{{ 'FEATURES.AGREEMENTS.COLUMNS.AREA' | translate }}</label>
    <app-multi-select
        [searchable]="true"
        [items]="data.areas"
        [ngModel]="selectedFilter.areas"
        (selectChange)="onMultiSelectChange('areas', $event)"
    />
</div>
<div *ngIf="config.fields.includes('endsInMonths')">
    <label for="">{{ 'FILTER.ENDS_IN_MONTHS' | translate }}</label>
    <app-dropdown
        [items]="data.endsInMonths"
        [ngModel]="selectedFilter.endsInMonths"
        (ngModelChange)="onSelectChange('endsInMonths', $event)"
    />
</div>
<div *ngIf="config.fields.includes('responsible')">
    <label for="">{{ 'COLUMNS.RESPONSIBLE' | translate }}</label>
    <app-multi-select
        [searchable]="true"
        [items]="users$ | async"
        [ngModel]="selectedFilter.responsible"
        (selectChange)="onMultiSelectChange('responsible', $event)"
        [placeholder]="
            'SELECT.SELECT_WITH_LABEL'
                | translate
                    : {
                          label: 'FEATURES.AGREEMENTS.RESPONSIBLE' | translate
                      }
        "
    />
</div>
<div *ngIf="config.fields.includes('customers')">
    <label for="">{{ 'FILTER.CUSTOMER' | translate }}</label>
    <app-multi-select
        [searchable]="true"
        [items]="data.customers"
        [ngModel]="selectedFilter.customers"
        (selectChange)="onMultiSelectChange('customers', $event)"
    />
</div>
<div *ngIf="config.fields.includes('counterparts')">
    <label for="">{{ 'FILTER.COUNTERPART' | translate }}</label>
    <app-multi-select
        [searchable]="true"
        [items]="data.counterparts"
        [ngModel]="selectedFilter.counterparts"
        (selectChange)="onMultiSelectChange('counterparts', $event)"
    />
</div>
<div *ngIf="config.fields.includes('status')">
    <label for="">{{ 'FILTER.AGREEMENT_STATUS' | translate }}</label>
    <app-multi-select
        [searchable]="true"
        [items]="data.status"
        [ngModel]="selectedFilter.status"
        (selectChange)="onMultiSelectChange('status', $event)"
    />
</div>
<div *ngIf="config.fields.includes('typeOfInventory')">
    <label for="">{{ 'FEATURES.AGREEMENTS.TYPE_OF_INVENTORY' | translate }}</label>
    <app-multi-select
        [searchable]="true"
        [items]="data.typeOfInventory"
        [ngModel]="selectedFilter.typeOfInventory"
        (selectChange)="onMultiSelectChange('typeOfInventory', $event)"
    />
</div>
<div *ngIf="config.fields.includes('manufacturer')">
    <label for="">{{ 'FEATURES.AGREEMENTS.MANUFACTURER' | translate }}</label>
    <app-multi-select
        [searchable]="true"
        [items]="data.manufacturer"
        [ngModel]="selectedFilter.manufacturer"
        (selectChange)="onMultiSelectChange('manufacturer', $event)"
    />
</div>
<div *ngIf="config.fields.includes('inventoryusers')">
    <label for="">{{ 'FEATURES.AGREEMENTS.USER' | translate }}</label>
    <app-multi-select
        [searchable]="true"
        [items]="data.inventoryusers"
        [ngModel]="selectedFilter.inventoryusers"
        (selectChange)="onMultiSelectChange('inventoryusers', $event)"
    />
</div>
<div *ngIf="config.fields.includes('listTypes')" class="listtypes">
    <label for="">{{ 'FEATURES.LISTTYPE.TYPE' | translate }}</label>
    <app-multi-select
        [searchable]="true"
        [items]="data.listTypes"
        [ngModel]="selectedFilter.listTypes"
        (selectChange)="onMultiSelectChange('listTypes', $event)"
    />
</div>
